// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactIntl from "react-intl";
import * as Core from "@material-ui/core";
import * as App_Icon$DvmAdminFrontendFr from "../../common/components/icons/App_Icon.bs.js";
import * as Theme_Colors$DvmAdminFrontendFr from "../../theme/Theme_Colors.bs.js";
import * as App_Typography$DvmAdminFrontendFr from "../../common/App_Typography.bs.js";
import * as Messages_Pool_Expenses$DvmAdminFrontendFr from "../../intl/messages/poolExpenses/Messages_Pool_Expenses.bs.js";
import * as Pool_Expenses_Available_Expenses_Modal$DvmAdminFrontendFr from "./Pool_Expenses_Available_Expenses_Modal.bs.js";

function Pool_Expenses_Available_Expenses_Button(Props) {
  var level = Props.level;
  var intl = ReactIntl.useIntl();
  var match = React.useState(function () {
        return null;
      });
  var setModal = match[1];
  return React.createElement(React.Fragment, undefined, React.createElement(Core.Button, {
                  onClick: (function (param) {
                      Curry._1(setModal, (function (param) {
                              return React.createElement(Pool_Expenses_Available_Expenses_Modal$DvmAdminFrontendFr.make, {
                                          onClose: (function (param) {
                                              Curry._1(setModal, (function (param) {
                                                      return null;
                                                    }));
                                            }),
                                          level: level
                                        });
                            }));
                    }),
                  children: React.createElement(Core.Grid, {
                        children: null,
                        container: true,
                        wrap: "nowrap"
                      }, React.createElement(Core.Grid, {
                            alignItems: "center",
                            children: React.createElement(App_Icon$DvmAdminFrontendFr.make, {
                                  size: /* Regular */2,
                                  type_: /* Hint */23,
                                  color: Theme_Colors$DvmAdminFrontendFr.secondaryBlue,
                                  fontWeight: "600"
                                }),
                            container: true,
                            item: true,
                            style: {
                              paddingRight: "3px"
                            }
                          }), React.createElement(Core.Grid, {
                            children: React.createElement(App_Typography$DvmAdminFrontendFr.make, {
                                  noWrap: true,
                                  style: {
                                    color: Theme_Colors$DvmAdminFrontendFr.secondaryBlue,
                                    fontWeight: "600"
                                  },
                                  children: intl.formatMessage(Messages_Pool_Expenses$DvmAdminFrontendFr.availableExpenses),
                                  variant: "subtitle"
                                }),
                            item: true
                          }))
                }), match[0]);
}

var make = Pool_Expenses_Available_Expenses_Button;

export {
  make ,
}
/* react Not a pure module */
